<div class="card">
  <div class="card-header d-flex justify-content-between align-items-center">
    <h4 class="card-title">{{name}} @if (hideRefreshBtn !== true) {
      <i class="fa fa-refresh refreshbtn" matSuffix
        (click)="refresh(); $event.stopPropagation()" [ngClass]="{'fa-spin': loading}">
      </i>
    }</h4>
    <ng-container class="pull-right" [ngTemplateOutlet]="tableTools"
    [ngTemplateOutletContext]="{ selected: selection.selected}"></ng-container>
  </div>
  <div class="card-body">
    @if (filterable) {
      <mat-form-field style="margin-bottom: -20px; margin-top: -30px;">
        <mat-label>Search</mat-label>
        <input matInput [formControl]="filterCtrl">
        @if (filterCtrl.value) {
          <button mat-button mat-icon-button matSuffix
            (click)="clearSearchField()"
            class="cross-btn">
            <mat-icon>close</mat-icon>
          </button>
        }
      </mat-form-field>
    }
    <mat-paginator #paginator (page)="pageChangeEvent($event)" [pageIndex]="pageIndex" [pageSizeOptions]="[10, 20, 50, 100, 500]" [pageSize]="pageSize" showFirstLastButtons>
    </mat-paginator>
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8" cdkDropList
      cdkDropListOrientation="horizontal" (cdkDropListDropped)="drop($event)">
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox (change)="$event? toggleAllRows(): null"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
            [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)" class="checkbox-cell"
            style="text-align: center">
          </mat-checkbox>
        </td>
      </ng-container>

      @if (showIndexColumn) {
        <ng-container matColumnDef="#">
          <th mat-header-cell *matHeaderCellDef class="checkbox-cell"> #
          </th>
          <td mat-cell *matCellDef="let element; let i = index" style="text-align: center">
            {{i + 1}}
          </td>
        </ng-container>
      }
      @for (column of columns; track column) {
        <ng-container [matColumnDef]="column.key">
          <th mat-header-cell *matHeaderCellDef
            [ngStyle]="column.width && {width:column.width, 'max-width': column.width}" mat-sort-header
            [sortActionDescription]="'Sort by {{column.name}}'" [disabled]="column.sortable === false">
            <span class="ellipsis">{{column.name}}</span>
          </th>
          <td mat-cell *matCellDef="let element"
            [ngStyle]="column.width && {width:column.width, 'max-width': column.width}" [style]="column.style">
            @switch (column.type) {
              @case ('datetime') {
                <span class="ellipsis">{{element[column.key] | date:
                'mediumDate'}}</span>
              }
              @case ('date') {
                <span class="ellipsis">{{element[column.key] | date: 'medium'}}</span>
              }
              @case ('music') {
                <audio controls preload="none" [style]="'width: 140px; height: 20px'">
                  <source [src]="element[column.key]" type="audio/mp3" />
                  Your browser does not support the audio tag.
                </audio>
              }
              @case ('pdf') {
                <span class="material-icons preview-icon"
                  (click)="$event.stopPropagation();openPreviewPDFModal(element[column.key])">
                  preview
                </span>
              }
              @case ('video') {
                <video controls preload="none" [width]="column.width"
                  [height]="column.height">
                  <source [src]="element[column.key]" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              }
              @case ('vimeo') {
                <span class="material-icons preview-icon"
                  (click)="$event.stopPropagation();openPreviewVimeoModal(element[column.key])">
                  play_circle_filled
                </span>
              }
              @case ('image') {
                <!-- <span class="material-icons preview-icon"
                  (click)="$event.stopPropagation();openPreviewImageModel(element[column.key][0])">
                  image
                </span> -->
                <span [ngStyle]="{width: column.width}" (click)="$event.stopPropagation();openPreviewImageModel(element[column.key][0])">
                  <img 
                    [src]="element[column.key][0]" 
                    [style]="column.style"
                  />
                </span>
              }
              @case ('imageArray') {
                @if (element[column.key] && element[column.key].length) {
                  @for (url of element[column.key]; track url) {
                    <img [src]="element[column.key]"
                      [width]="(+column.width)/element[column.key].length" [height]="column.height" />
                  }
                }
              }
              @case ('link') {
                <a class="ellipsis" target="_blank" [href]="element[column.key]">
                {{element[column.key]}} </a>
              }
              @case ('json') {
                <span class="material-icons preview-icon"
                  (click)="$event.stopPropagation();openPreviewJSONModal(element[column.key])">
                  preview
                </span>
              }
              @case ('self') {
                <span class="material-icons preview-icon"
                  (click)="$event.stopPropagation();openPreviewJSONModal(element)">
                  preview item
                </span>
              }
              @case ('defaultTools') {
                <div class="btn-group" role="group" aria-label="Basic example">
                  <app-defaulttools [element]="element" (editItemEvent)="editItemClicked($event)"
                    (cloneItemEvent)="cloneItemClicked($event)"
                    (deleteItemEvent)="deleteItemClicked($event)">
                  </app-defaulttools>
                </div>
              }
              @case ('custom') {
                <ng-container [ngTemplateOutlet]="column.cellTemplate"
                  [ngTemplateOutletContext]="{ item: element}">
                </ng-container>
              }
              @default {
                <span class="ellipsis">{{element[column.key]}}</span>
              }
            }
          </td>
        </ng-container>
      }

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row
        *matRowDef="let row; columns: displayedColumns"
        [ngClass]="{ 'active': row._id === selectedId }"
        (click)="selection.toggle(row)">
      </tr>
      <tr *matNoDataRow>
        <td class="mat-cell">No data matching the filter</td>
      </tr>

    </table>
  </div>
  @if (paginationPosition === 'both') {
    <mat-paginator
      class="paginator-container"
      (page)="pageChangeEvent($event)"
      [pageSize]="paginator.pageSize"
      [pageIndex]="paginator.pageIndex"
      [length]="paginator.length"
      [pageSizeOptions]="paginator.pageSizeOptions"
      showFirstLastButtons>
    </mat-paginator>
  }
  <!-- <mat-paginator (page)="pageChangeEvent($event)" [pageIndex]="pageIndex" [pageSizeOptions]="[10, 20, 50, 100, 500]" [pageSize]="pageSize" showFirstLastButtons>
</mat-paginator> -->
</div>